export enum TimeFormatEnums {
  T_12_HOURS, // 12 hours  Ex: 1:15pm
  T_24_HOURS, // 24 hours	Ex: 13:15
  T_DECIMAL, // 24 hours	  Ex: 13.25
}
